import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=718c98cf&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=718c98cf&prod&lang=scss&scoped=true"
import style1 from "./UsersList.vue?vue&type=style&index=1&id=718c98cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c98cf",
  null
  
)

export default component.exports